module.exports = __webpack_public_path__ + "static/media/Grief AndLoss.105ebafc.svg";